module.exports = Object.freeze({
  CITY: 'city',
  COUNTY: 'county',
  STATE: 'state',
  FEDERAL: 'federal'
})